import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material';
import { NpsService } from '@api/nps/nps.service';
import { isNil } from 'lodash';
import { NetPromoterScoreModalComponent } from './net-promoter-score-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
import * as i2 from "../../api/nps/nps.service";
var NetPromoterScoreModalService = /** @class */ (function () {
    function NetPromoterScoreModalService(matDialog, npsService) {
        this.matDialog = matDialog;
        this.npsService = npsService;
    }
    NetPromoterScoreModalService.prototype.open = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var nps;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.npsService.getNps()];
                    case 1:
                        nps = _a.sent();
                        if (!isNil(nps)) {
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, this.matDialog.open(NetPromoterScoreModalComponent, { panelClass: 'nps-dialog' })
                                .afterClosed()
                                .toPromise()];
                }
            });
        });
    };
    NetPromoterScoreModalService.prototype.close = function () {
        this.matDialog.closeAll();
    };
    NetPromoterScoreModalService.prototype.saveNPS = function (score, comment) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.npsService.postNps(score, comment)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NetPromoterScoreModalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NetPromoterScoreModalService_Factory() { return new NetPromoterScoreModalService(i0.ɵɵinject(i1.MatDialog), i0.ɵɵinject(i2.NpsService)); }, token: NetPromoterScoreModalService, providedIn: "root" });
    return NetPromoterScoreModalService;
}());
export { NetPromoterScoreModalService };
